import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from '../../../../featureFlags';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';
import Show from './Show.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/resources'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'settings_resources_index',
          meta: {
            permissions: ['administrator'],
            featureFlag: FEATURE_FLAGS.PLANNING_RESOURCES,
          },
          component: Index,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/resources/:resourceId'),
      name: 'settings_resources_show',
      meta: {
        permissions: ['administrator'],
        featureFlag: FEATURE_FLAGS.PLANNING_RESOURCES,
      },
      component: Show,
    },
  ],
};
